import React from "react";
import {connect} from "react-redux";
import Validator from "validator";
import Recaptcha from "react-recaptcha"
import spinner from "../../images/icons/spinner.svg";
class ContactUs extends React.Component {


    state = {
        fields: {
            email: "",
            formName: "",
            subject: "",
            message: ""
        },
        submitted: false,
        errors: {},

    };


    onChange = e =>
      this.setState({
          fields: {...this.state.fields, [e.target.name]: e.target.value}
      });

    onSubmit = e => {
        e.preventDefault();
        const errors = this.validate(this.state.fields);
        this.setState({errors});
        if (Object.keys(errors).length === 0) {
            this.setState({loading: true});
            this.props
              .submit(this.state.fields)
            this.setState({submitted : true});

        }
    };

    validate = fields => {
        const errors = {};
        if (!Validator.isEmail(fields.email)) errors.email = "Please enter a valid email";
        if (!fields.formName) errors.formName = "Please enter name";
        if (!fields.message) errors.message = "Can't be blank";
        return errors;
    };


    render() {
        const {fields, errors, submitted} = this.state;

        return (
          <div className="rob-contact-form">
              <div className="container">
                  <div className="row">
                      <div className="col-12">
                          <div className={submitted ? "rob-contact-form__spinner active" : "rob-contact-form__spinner" }>
                              <img src={spinner} alt={""} />
                          </div>
                          <form acceptCharset="UTF-8"
                                onSubmit={this.onSubmit}
                                className={submitted ? "rob-contact-form__submitted" : "" }>
                              <input type="hidden" name="action" value="guest-entries/save"/>
                              <input type="hidden" name="sectionUid" value="00be4aa6-395d-4e27-86cb-767bf7d6bcc7"/>
                              <div className="row">
                                  <div className="col-6">
                                      <div className={
                                          errors.formName ? "rob-form-group rob-form-error" : "rob-form-group"
                                      }>
                                          <input type="text" name="formName"
                                                 placeholder="Name*"
                                                 value={fields.formName}
                                                 className="rob-input-text"
                                                 onChange={this.onChange}
                                                 maxLength="50"/>
                                          <small className="rob-input-text--error__message">{errors.formName}</small>
                                      </div>
                                  </div>
                                  <div className="col-6">
                                      <div className={
                                          errors.email ? "rob-form-group rob-form-error" : "rob-form-group"
                                      }>
                                          <input type="text" name="email"
                                                 placeholder="Email*"
                                                 className="rob-input-text"
                                                 value={fields.email}
                                                 onChange={this.onChange}
                                                 maxLength="50"/>
                                          <small className="rob-input-text--error__message">{errors.email}</small>
                                      </div>
                                  </div>
                              </div>

                              <div className="row">
                                  <div className="col-12">
                                      <div className="rob-form-group">
                                          <input type="text" name="subject"
                                                 placeholder="Subject"
                                                 value={fields.subject}
                                                 onChange={this.onChange}
                                                 className="rob-input-text"/>
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-12">
                                      <div className={
                                          errors.formName ? "rob-form-group rob-form-error" : "rob-form-group"
                                      }>
                                          <textarea name="message"
                                                    className="rob-input-text"
                                                    placeholder="Write Message here"
                                                    rows="15"
                                                    value={fields.message}
                                                    onChange={this.onChange}/>

                                          <small className="rob-input-text--error__message">{errors.message}</small>
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-12">
                                      <div className="rob-form__recaptcha">
                                          <Recaptcha
                                            sitekey="6LfNR28UAAAAAIHs3-DwlmUgdHo0U4oNckk3UHZb"
                                          />
                                      </div>
                                  </div>
                              </div>
                              <div className="row">
                                  <div className="col-12 sib-contact__submit">
                                      <button type="submit" value="Submit"
                                           className="button button-primary">
                                          Submit
                                      </button>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
        )
    }
}

ContactUs.defaultProps = {
                        blockLoop: [],

                        };


function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(ContactUs);




// WEBPACK FOOTER //
// ./src/components/elements/ContactUs.js